/**
 * PRD.330 — Canonical Reports routes. Dependency-free so the permission map,
 * navigation, Home and tests all share one path constant.
 */
export const CLINIC_COLLECTION_DETAILS_PATH = '/reports/clinic-collection-details';
